import React from 'react';
import classNames from 'classnames/bind';
import { SwiperSlide } from 'swiper/react';

// Components
import Slider from '../../../Slider';
import Button from '../../../Button';
import Amount from '../../../Amount';
import VariationInfo from '../../../VariationInfo';
import useUpsaleSlider from '../useUpsaleSlider';

// Icons
import PlusIcon from '../../../../icons/plus.svg';

// Styles
import styles from './UpsaleSlider.styl';

const cx = classNames.bind(styles);

export default function UpsaleSlider() {
  const { isLoading, handleAddToCart, variations } = useUpsaleSlider();

  if (!variations) {
    return <div className={cx('UpsaleSlider__empty')} />;
  }

  const swiperParams = {
    slidesPerView: 'auto',
    spaceBetween: 8,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 8,
  };

  return (
    <div
      className={cx('UpsaleSlider')}
      style={variations.length < 8 ? { marginBottom: 10 } : { marginBottom: 0 }} // это размер пагинации
    >
      <Slider
        className={cx('UpsaleSlider__slider')}
        isOutsidePagination={variations.length < 8}
        swiperParams={swiperParams}
        newest
      >
        {variations.map((newVariation, index) => {
          const { id, name, image_list, old_price, price } = newVariation;

          return (
            <SwiperSlide className={cx('UpsaleSlider__slide')} key={id}>
              <div className={cx('UpsaleSlider__slide_firstBlock')}>
                <div className={cx('UpsaleSlider__slide-image')}>
                  <img src={image_list} alt={name} />
                </div>
                <div className={cx('UpsaleSlider__slide-group')}>
                  <div className={cx('UpsaleSlider__slide-name')}>{name}</div>
                  <VariationInfo
                    className={cx('UpsaleSlider__slide-description')}
                    {...newVariation}
                  />
                </div>
              </div>

              <div className={cx('UpsaleSlider__slide-end')}>
                <Amount
                  className={cx('UpsaleSlider__slide-amount')}
                  value={old_price || price}
                  newValue={price}
                  size="s"
                />
                <Button
                  className={cx('UpsaleSlider__slide-button')}
                  isLoading={isLoading.includes(id)}
                  onClick={() => handleAddToCart(newVariation, index)}
                >
                  <PlusIcon className={cx('UpsaleSlider__slide-plus')} />
                </Button>
              </div>
            </SwiperSlide>
          );
        })}
      </Slider>
    </div>
  );
}
